import React from 'react';
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from '@mui/material';

// Identify-first (common-URL) login: when the entered email/mobile is known to
// more than one tenant, let the user pick which organisation to sign in to.
// Avatar falls back to the tenant's initial when there is no (or a broken) logo.
export default function TenantPicker({ open, tenants, onSelect, onCancel }) {
  return (
    <Dialog open={Boolean(open)} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Select your organisation</DialogTitle>
      <List>
        {(tenants || []).map((tenant) => (
          <ListItemButton key={tenant.tenantId} onClick={() => onSelect(tenant)}>
            <ListItemAvatar>
              <Avatar src={tenant.logo || undefined} alt={tenant.name || 'tenant'}>
                {(tenant.name || '?').charAt(0).toUpperCase()}
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={tenant.name} />
          </ListItemButton>
        ))}
      </List>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
